export const dashboardBaseUrl = process.env.REACT_APP_ENV === 'dev' ? 'https://app-dev.karir.ai' : 'https://app.karir.ai';

const baseUrls = {
    dashboardBaseUrl
}

export default baseUrls;